import React, { useState, useEffect } from 'react';
import { useDropzone, FileWithPath } from 'react-dropzone'; // Removed FileRejection import
import { FaReceipt } from 'react-icons/fa';

interface IAttachFileProps {
  onFilesUpload?: (files: FileInfo[], expLabel?: string) => void;
  DnDMessage?: string;
  customClasses?: string;
  expenseLabel?: string;
  hasReceipts?: boolean;
  hasRestrictions?: boolean;
  successfulReceipts?: number;
  disabled?: boolean;
}

export type FileInfo = {
  fileContent: string | ArrayBuffer | null;
  fileInfo: FileWithPath;
};

const AttachFile: React.FC<IAttachFileProps> = ({
  onFilesUpload,
  DnDMessage,
  disabled,
  customClasses,
  expenseLabel,
  successfulReceipts,
  hasRestrictions,
}) => {
  const [filesReady, setFilesReady] = useState<FileInfo[]>([]);
  const [inputFilesCount, setInputFilesCount] = useState(0);
  const [showIcon, setShowIcon] = useState(false);

  useEffect(() => {
    setShowIcon(!!successfulReceipts && successfulReceipts > 0);
  }, [successfulReceipts]);

  useEffect(() => {
    if (inputFilesCount === filesReady.length) {
      onFilesUpload?.(filesReady, expenseLabel);
    }
  }, [inputFilesCount, filesReady, onFilesUpload, expenseLabel]);

  // Accept files workaround for react-dropzone v14+
  const acceptFiles: Record<string, string[]> | undefined = hasRestrictions
    ? { 'application/pdf': ['.pdf'] }
    : undefined;
  
  type FileRejection = {
    file: File;
    errors: { code: string; message: string }[];
  };    

  const { getRootProps, getInputProps } = useDropzone({
    onDropAccepted: (files) => {
      setInputFilesCount(files.length);
      setFilesReady([]); // reset

      files.forEach((file) => {
        const reader = new FileReader();
        reader.onabort = () => console.log('File reading was aborted');
        reader.onerror = () => console.log('File reading has failed');
        reader.onload = () => {
          const arrayBuffer = reader.result; // ArrayBuffer
          setFilesReady((prev) => [
            ...prev,
            { fileContent: arrayBuffer, fileInfo: file },
          ]);
        };
        reader.readAsArrayBuffer(file);
      });      
    },
    onDropRejected: (files: File[]) => {
      const rejectedFiles = files as unknown as FileRejection[];
      rejectedFiles.forEach((rej) => {
        console.warn('Rejected file:', rej.file.name);
        rej.errors.forEach((err) => console.warn(err.code, err.message));
      });
    },
    disabled,
    accept: acceptFiles as unknown as string | string[], // cast to satisfy TS
    maxSize: 4_000_000, // auto reject >4MB
  });

  const classes = `border border-dashed p-4 text-center ${
    disabled ? 'cursor-not-allowed' : 'cursor-pointer'
  } ${customClasses ?? ''}`;

  return (
    <div {...getRootProps()} className={classes}>
      <div className="flex items-center justify-center">
        {!showIcon ? DnDMessage : ''}
        {showIcon && (
          <span className="text-gray-500 rounded-xl p-[2px_4px]">
            {successfulReceipts}
          </span>
        )}
        {showIcon && (
          <div className="text-gray-500 text-[25px]">
            <FaReceipt />
          </div>
        )}
      </div>
      <input {...getInputProps()} />
    </div>
  );
};

export default AttachFile;


// WEBPACK FOOTER //
// ./src/components/project-billing/components/AttachFile.tsx